<template>
  <section class="curation-list layout-col">
    <BaseContainerSpread
      class="jps-list-header"
      role="group"
      tag="header"
    >
      <h1 class="jps-lh-title">
        <BaseIcon name="koicon/koicon-07" size="size-full" class="jps-lh-title-icon" />
        <span class="jps-lh-title-span">{{
          lss('ギャラリー', 'Galleries')
        }}</span>
      </h1>
      <p class="jps-lh-description">
        {{
          lst(dapLangGlobal.galleryIntroduction, ls(dapLangGlobal.serviceName))
        }}
      </p>
    </BaseContainerSpread>

    <BaseContainerSpread
      v-if="ss"
      tag="div"
      class="gallery-page-search-box"
    >
      <SearchBox :ss="ss" />
    </BaseContainerSpread>

    <BaseContainerSpread id="jps-gallery-index-container1">
      <UiCurationSearchResult :ss="ss" />
    </BaseContainerSpread>

    <CurationRenderer :curation="curation" :noheader="true" />
  </section>
</template>

<script lang="ts" setup>
import { dapLangGlobal } from '#imports'

definePageMeta({
  qsearch: true,
})

const { getPageAndCache } = usePage()
const { meta, page } = await getPageAndCache()
useHead(meta)

const { ls, lss, lst } = useI18n()
const { searchCuration } = useCuration()
const dataStore = useDataStore()

//data
const curation = computed(() => {
  if (page) {
    return dataStore.curation(getPageCurationId(page.id))
  }
  return null
})

const ss: Ref<SearchStore<CustomSearchDefinition>> = ref(null)
onBeforeMount(async () => {
  ss.value = useSearch<CustomSearchDefinition>(systemGallerySearchCs(), searchCuration, {
    queryRewriter: (q: SearchQuery) => {
      q.permission = 'P'
      return q
    },
  })
  await ss.value.executeFullFacet(['topic', 'keyword'])
  await nextTick(() => {
    ss.value.restoreQuery()
  })
})
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.curation-list {
  row-gap: 1rem;

  .jps-search-detail-menu {
    justify-content: center !important;
  }
}

.gallery-page-search-box {
  :deep(.jps-search-detail-menu) {
    @include is-desktop {
      justify-content: center;
    }
  }
}
// REVIEW 応急措置
#jps-gallery-index-container1 {
  :deep(.grid-item) {
    transform: translateZ(0);
  }
}
</style>
